import { combineReducers } from 'redux';
import { connectRouter } from 'connected-react-router';
import entities from './entities';
import pagination from './pagination';
import search, { cachedSearch } from './search';
import ui from './ui';

export default history =>
  combineReducers({
    router: connectRouter(history),
    entities,
    pagination,
    search,
    cachedSearch,
    ui,
  });
